import { createAsyncThunk } from '@reduxjs/toolkit'

import {
  CalculateIncidentActionsCostsResponse,
  Incident,
  IncidentResponse,
  MapIncidentToAuditsResponse,
  SourceIncidentType,
} from '../../types/incidentTypes'
import {
  addIncidentApi,
  addIncidentsToActionApi,
  calculateIncidentActionsCostsApi,
  deleteIncidentApi,
  getAllIncidents,
  getIncidentByActionIdApi,
  getIncidentbyIdApi,
  getIncidentsByMissionIdApi,
  mapIncidentToAuditsApi,
  removeIncidentsFromActionApi,
  updateIncidentApi,
} from '../../api/incidentApi'
import { getIncidentsFromRelatedControls } from '../../api/securityControlsApi'
import { handleError } from '../../utils/errorHandler'

export const getIncidents = createAsyncThunk<
  {
    incidents: Incident[]
    total: number
    totalPages: number
    status?: number
    erreur?: boolean
    message?: string
  },
  {
    search?: string
    page?: number
    pageSize?: number
    query?: string
    field?: string
  },
  { rejectValue: string }
>('incident/getAllIncidents', async ({ search, page, pageSize }, thunkAPI) => {
  try {
    const response = await getAllIncidents({ search, page, pageSize })
    return {
      incidents: response.incidents,
      total: response.total,
      totalPages: response.totalPages ?? 0,
      status: response.status,
      message: response.message,
      erreur: response.erreur,
    }
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
export const fetchIncidentsFromRelatedControls = createAsyncThunk<
  Incident[],
  string,
  { rejectValue: string }
>(
  'securityControls/fetchIncidentsFromRelatedControls',
  async (id, thunkAPI) => {
    try {
      const response = await getIncidentsFromRelatedControls(id)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)
export const deleteIncident = createAsyncThunk<
  void,
  string,
  { rejectValue: string }
>('incident/deleteIncident', async (IncidentId, thunkAPI) => {
  try {
    await deleteIncidentApi(IncidentId)
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const addIncident = createAsyncThunk<
  Incident,
  Incident,
  { rejectValue: string }
>('incident/addIncident', async (newIncident, thunkAPI) => {
  try {
    const response = await addIncidentApi(newIncident)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
export const getIncidentbyId = createAsyncThunk<
  Incident,
  string,
  { rejectValue: string }
>('incident/getIncidentbyId', async (IncidentId, thunkAPI) => {
  try {
    const response = await getIncidentbyIdApi(IncidentId)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const updateIncident = createAsyncThunk<
  Incident,
  { updatedIncident: Incident; _id: string },
  { rejectValue: string }
>('incident/updateIncident', async ({ updatedIncident, _id }, thunkAPI) => {
  try {
    const response = await updateIncidentApi(updatedIncident, _id)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const getIncidentByMissionId = createAsyncThunk<
  IncidentResponse,
  string,
  { rejectValue: string }
>('incident/getIncidentByMissionId', async (MissionId, thunkAPI) => {
  try {
    const response = await getIncidentsByMissionIdApi(MissionId)
    return response.data
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const getIncidentByActionId = createAsyncThunk<
  IncidentResponse,
  string,
  { rejectValue: string }
>('incident/getIncidentByActionId', async (ActionId, thunkAPI) => {
  try {
    const response = await getIncidentByActionIdApi(ActionId)
    return response.data
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const addIncidentsToAction = createAsyncThunk<
  IncidentResponse,
  { SourceIncident: string[]; _id: string },
  { rejectValue: string }
>(
  'incident/addIncidentsToAction',
  async ({ SourceIncident, _id }, thunkAPI) => {
    try {
      const response = await addIncidentsToActionApi(SourceIncident, _id)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)
export const removeIncidentsFromAction = createAsyncThunk<
  IncidentResponse,
  { SourceIncident: SourceIncidentType; _id: string },
  { rejectValue: string }
>(
  'incident/addIncidentsToAction',
  async ({ SourceIncident, _id }, thunkAPI) => {
    try {
      const response = await removeIncidentsFromActionApi(SourceIncident, _id)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)
export const mapIncidentToAudits = createAsyncThunk<
  MapIncidentToAuditsResponse,
  string,
  { rejectValue: string }
>('incident/mapIncidentToAudits', async (incidentId, thunkAPI) => {
  try {
    const response = await mapIncidentToAuditsApi(incidentId)
    return response
  } catch (error) {
    console.error(error)
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
export const calculateIncidentActionsCosts = createAsyncThunk<
  CalculateIncidentActionsCostsResponse,
  string,
  { rejectValue: string }
>('incident/calculateIncidentActionsCosts', async (incidentId, thunkAPI) => {
  try {
    const response = await calculateIncidentActionsCostsApi(incidentId)
    return response
  } catch (error) {
    console.error(error)
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
